// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"homeBanner_scrollbar__1jZWs","date":"homeBanner_date__3w4KP"};